<template>
  <v-dialog
    v-model="showModal"
    width="640px"
    content-class="view-image-modal"
    :transition="isMobile ? 'dialog-bottom-transition' : 'dialog-transition'"
  >
    <v-btn class="close" icon @click="closeModal" data-test-id="CLOSE-REVIEW">
      <v-icon>close</v-icon>
    </v-btn>
    <v-card v-if="imgSrc" class="image-view-frame" data-test-id="REVIEW-IMG-DIALOG">
      <img
        v-if="docType !== $constants.EKYC_KEY.VIDEO"
        :src="imgSrc"
        alt
        :style="{
          transform: 'scale3d(' + scale + ',' + scale + ',' + scale + ')'
        }"
      />
      <video :src="imgSrc" controls v-else></video>
    </v-card>
    <v-layout row mt-2 v-if="docType !== $constants.EKYC_KEY.VIDEO">
      <v-flex xs12 sm8 offset-sm2>
        <v-slider
          :min="0"
          :max="10"
          v-model="zoom"
          @input="trackingZoomAction"
          append-icon="zoom_in"
          prepend-icon="zoom_out"
          @click:append="zoomIn"
          @click:prepend="zoomOut"
        ></v-slider>
      </v-flex>
    </v-layout>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
    imgSrc: {
      type: String,
      require: true
    },
    eventType: {
      type: String,
      require: false
    }
  },
  data() {
    return {
      showModal: false,
      zoom: 0,
      docType: null
    }
  },
  computed: {
    scale() {
      return 1 + this.zoom / 5
    },
    ...mapState({
      fingerprint: (state) => state.user.fingerprint,
      userProfile: (state) => state.user.profile
    })
  },
  methods: {
    closeModal() {
      this.showModal = false

      if (this.eventType) {
        const trackingParams = {
          user_id: this.userProfile._id,
          city_id: this.userProfile.city_id,
          platform: 'web',
          os: window.navigator.userAgent,
          device_id: this.fingerprint
        }

        this.$analyticTracking.logEvent(
          this.$trackingEvents.ACTIONS.CLICK,
          this.eventType,
          trackingParams
        )
      }
    },
    zoomIn() {
      this.zoom++
    },
    zoomOut() {
      this.zoom--
    },
    trackingZoomAction() {
      this.$analyticTracking.logEvent(
        this.$trackingEvents.ACTIONS.CLICK,
        this.$trackingEvents.EVENTS.NEW_ORDER_ZOOM_IMAGE,
        {}
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.image-view-frame {
  display: flex;
  min-height: 300px;
  align-items: center;
  justify-content: center;
  position: relative;
  background: #222;
  border-radius: 0;
  box-shadow: none;
  overflow: hidden;
}

img {
  max-width: 100%;
  max-height: calc(100% - 4rem);
  transition: all 0.3s linear;
}
</style>
<style lang="scss">
.view-image-modal {
  position: relative;
  padding: 56px 0 0 0;
  background: #fff;
  max-height: 90vh;

  .close {
    position: absolute !important;
    top: 4px;
    right: 2px;
    z-index: 1;
  }

  .v-input--slider {
    margin: 8px 16px;
  }
}

@media screen and (max-width: 480px) {
  .view-image-modal {
    &.v-dialog {
      margin: 0;
      margin-top: auto;
      max-height: 90% !important;
      border-radius: 8px 8px 0 0;
    }
  }
}
</style>
